export const config = {
  submissionName: {
    required: true,
    rules: [
      (value: string) => ({
        valid: !/[\\/*?":|<>]/g.test(value),
        'data-error': 'v_submissionNameIllegalCharacters'
      }),
      (value: string) => ({
        valid: value.length <= 150,
        'data-error': 'v_submissionNameTooLong'
      })
    ]
  },
  project: { required: true, value: null },
  projectManager: { required: true, value: [] },
  dueDate: { value: 'specificDate', valid: true },
  specificDate: {
    required: true,
    value: null,
    rules: [
      (value: Date) => ({
        valid: value > new Date(),
        'data-error': 'v_dueDateInThePast'
      })
    ]
  },
  sourceLanguage: { required: true, value: null },
  targetLanguage: { required: true, value: [], disabled: true },
  workflow: { required: true, value: null },
  uploadedFiles: { value: [] },
  deletedFiles: { value: [] },
  isFavorite: { value: false },
  instructions: { value: '' },
  notes: { value: '' },
  referenceFiles: { value: [] },
  batchId: { value: null },
  targetFormat: { value: null },
  description: { value: '' },
  mediaAssetsNumber: {
    value: '',
    required: false,
    rules: [
      (value: string) => ({
        valid: !/[\\/*?":|<>]/g.test(value),
        'data-error': 'v_mediaAssetIllegalCharacters'
      }),
      (value: string) => ({
        valid: value.length <= 255,
        'data-error': 'v_mediaAssetMamIdTooLong'
      })
    ]
  },
  template: { value: null },
  submissionFolder: { value: '' },
  isMultiBatch: { value: false },
  batchesWithFiles: { value: false },
  quoteEnabled: { value: false },
  claimScope: { required: true, value: 'LANGUAGE' }
};


/**
 * Form configuration for TPT(internal mode)
 */
export const tptConfig = {
  ...config,
  job: {
    required: true,
    value: '',
    rules: [
      (value: string) => ({
        valid: !/[\\/*?":|<>]/g.test(value),
        'data-error': 'v_jobNumberIllegalCharacters'
      })
    ]
  },
  paClient: { required: true, value: null }
};